








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { AssetTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxAssetType extends Vue {
  private types: AssetTypeDto[] | null = [];
  private selectedType = new AssetTypeDto();
  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: AssetTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: AssetTypeDto) {
    this.$emit("assetTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .assetType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
